import Vue from 'vue';
import request from '../../utils/request';
import { toYuan } from '../../utils/unit-conversion';
import detailInfo from '../../components/insurance/detail-info.vue';
export default Vue.extend({
    name: 'login',
    components: {
        detailInfo: detailInfo,
    },
    created: function () {
        this.inforQuery = this.$route.query.inforQuery;
    },
    mounted: function () {
        // this.inforQuery = this.$route.query.inforQuery
        this.query = JSON.parse(this.inforQuery);
        this.getInfo(this.query);
    },
    computed: {},
    watch: {},
    data: function () {
        return {
            inforQuery: '',
            query: {},
            info: [
                {
                    key: '',
                    value: '申请时间',
                },
                {
                    key: '',
                    value: '订单号',
                },
                {
                    key: '',
                    value: '保单数',
                },
                {
                    key: '',
                    value: '申贷总额',
                },
                {
                    key: '',
                    value: '商户账户',
                },
            ],
            operation: false,
            activeName: 'first',
            type: '',
            infoText: '',
            polictData: {},
            active: 0,
        };
    },
    methods: {
        getInfo: function (query) {
            var _this = this;
            request({
                method: 'post',
                url: '/proxy/api/application/info',
                data: {
                    applicationCode: query.applicationCode,
                },
            }).then(function (res) {
                if (!res)
                    return;
                if (!res.errorCode) {
                    _this.updateLoan(res.data);
                }
            });
        },
        updateLoan: function (data) {
            this.polictData = data;
            var _a = this.polictData, applyTime = _a.applyTime, applicationCode = _a.applicationCode, policyCount = _a.policyCount, expectedAmount = _a.expectedAmount, bankName = _a.bankName, bankCardNo = _a.bankCardNo, actualAmount = _a.actualAmount;
            var status = this.query.status;
            this.info[0].key = applyTime;
            this.info[1].key = applicationCode;
            this.info[2].key = policyCount;
            this.info[3].key = toYuan(expectedAmount).toFixed(2);
            this.info[4].key = bankName + "(" + bankCardNo + ")";
            if (status === 'APPLIED') {
                this.infoText = '我们将在2个工作日内审核。';
                this.active = 1;
            }
            else if (status === 'AUDIT_PASS') {
                this.infoText = '我们将在2个工作日内放款到您的商户账号中。';
                this.active = 2;
                this.info.push({
                    key: toYuan(actualAmount).toFixed(2),
                    value: '放贷总额',
                });
            }
            else if (status === 'AUDIT_REFUSED') {
                this.infoText = '您的申请均未通过，请核对后再试。';
                this.active = 1;
            }
            else if (status === 'LENT') {
                this.infoText = '您申请的贷款已放款到商户账户中，请注意查收！';
                this.info.push({
                    key: toYuan(actualAmount).toFixed(2),
                    value: '放贷总额',
                });
                this.active = 3;
            }
        },
    },
});
